/** Room code alphabet (DESIGN-server §3.3): no vowels (no accidental words), no 0/O/1/I. */
export const ROOM_CODE_ALPHABET = 'BCDFGHJKLMNPQRSTVWXYZ23456789';
export const ROOM_CODE_LENGTH = 5;
/**
 * Random room code. `rand` returns a float in [0, 1); defaults to `Math.random` (callers in the
 * engine must pass their seeded RNG instead).
 */
export function randomCode(length = ROOM_CODE_LENGTH, rand = Math.random) {
    let out = '';
    for (let i = 0; i < length; i++) {
        out += ROOM_CODE_ALPHABET[Math.floor(rand() * ROOM_CODE_ALPHABET.length) % ROOM_CODE_ALPHABET.length];
    }
    return out;
}
const CODE_RE = new RegExp(`^[${ROOM_CODE_ALPHABET}]{${ROOM_CODE_LENGTH}}$`);
/** Uppercases and validates user input; returns null if not a well-formed code. */
export function normalizeCode(input) {
    const c = input.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
    return CODE_RE.test(c) ? c : null;
}
//# sourceMappingURL=ids.js.map